import BaseMap from './base-map'

const DestinationsMap = (function () {

	const init = function (mapEl) {
		if (typeof moresoda === "undefined") {
			setTimeout(init, 200);
		} else {
			const options = {
				center: new google.maps.LatLng(moresoda.mapMarkers[0].lat, moresoda.mapMarkers[0].lng),
				streetViewControl: false,
				mapTypeId: google.maps.MapTypeId.ROADMAP
			};
			const map = BaseMap.init(mapEl, options);
			loadMap(map);
		}
	}

	const loadMap = function (map) {

		google.maps.event.addListenerOnce(map, 'bounds_changed', function (event) {
			if (this.getZoom() > 12) {
				this.setZoom(12);
				console.log("zoom set");
			}
		});

		var infoWindow = new google.maps.InfoWindow();

		//Create LatLngBounds object.
		var latlngbounds = new google.maps.LatLngBounds();

		for (var i = 0; i < moresoda.mapMarkers.length; i++) {
			var data = moresoda.mapMarkers[i]
			var myLatlng = new google.maps.LatLng(data.lat, data.lng);
			var marker = new google.maps.Marker({
				position: myLatlng,
				map: map,
				title: data.title
			});
			(function (marker, data) {
				google.maps.event.addListener(marker, "click", function (e) {
					map.panTo(marker.getPosition());
					infoWindow.setContent(`<div><div class="marker"><div class="marker__row"><a href="${data.url}" class="marker__col marker__col--image"><img src="${data.image}" alt="${data.title}" class="img marker__img"></a><div class="marker__col marker__col--content"><h4 class="marker__title">${data.title}</h4><p>${data.description}</p><a href="${data.url}" class="button button--icon button--right">More details</a></div></div></div></div>`);
					infoWindow.open(map, marker);
				});
			})(marker, data);

			//Extend each marker's position in LatLngBounds object.
			latlngbounds.extend(marker.position);
		}

		//Get the boundaries of the Map.
		var bounds = new google.maps.LatLngBounds();

		//Center map and adjust Zoom based on the position of all markers.
		map.setCenter(latlngbounds.getCenter());
		map.fitBounds(latlngbounds);
	}

	return {
		init: init
	};

})();

export default DestinationsMap;